import Vue from 'vue'
import '@/i18n/index'

import { unmaskText } from '@/util/helpers'
import {
  MAX_DISPUTE_CREATION_DAYS_LIMIT,
  MIN_DISPUTE_CREATION_DAYS_LIMIT,
  isEmptyDisputeCreationDaysLimit,
} from '@/util/disputeCreationDaysLimit'
import { validateCPF, validateCNPJ } from './validate'

const { i18n } = Vue

export const required = [(v) => (!!v && (!(typeof v === 'string') || v.trim() != '')) || i18n.translate('rules.required')]
export const emailRule = [
  (value) =>
    value
      ? /([a-zA-Z0-9])([a-zA-Z0-9_+.-]+)@((([a-zA-Z0-9-]{2,})+\.)+[a-zA-Z_+-]{2,})/g.test(
          value
        ) || i18n.translate('rules.email')
      : false,
]

export const nonRequiredEmailRule = [
  (value) =>
    value
      ? /([a-zA-Z0-9])([a-zA-Z0-9_+.-]+)@((([a-zA-Z0-9-]{2,})+\.)+[a-zA-Z_+-]{2,})/g.test(
          value
        ) || i18n.translate('rules.email')
      : true,
]

export const passwordRule = [
  (v) =>
    (v ? v.length >= 5 && v.length <= 20 : true) ||
    i18n.translate('rules.password'),
]

export const matchRule = (value, match) => {
  return (!!value && value === match) || i18n.translate('rules.passwordNeedsToBeTheSame')
}

export const documentRule = [
  (value) => {
    if (!value) return false || i18n.translate('rules.required')

    const clearedValue = value.replace(/[^\d]+/g, '')

    if (clearedValue.length <= 11) return validateCPF(clearedValue) || i18n.translate('rules.cpfInvalid')
    else return validateCNPJ(clearedValue) || i18n.translate('rules.cnpjInvalid')
  },
]

export const internationalDocumentNonRequiredRule = [
  (value) => {
    if (!value) return true

    const clearedValue = value.replace(/[^\d]+/g, '')

    if (clearedValue.length < 8 || clearedValue.length > 20) return false || i18n.translate('rules.cpfInvalid')
    else return true
  }
]

export const internationalDocumentRule = [
  (value) => {
    if (!value) return false || i18n.translate('rules.required')

    const clearedValue = value.replace(/[^\d]+/g, '')

    if (clearedValue.length < 8 || clearedValue.length > 20) return false || i18n.translate('rules.cpfInvalid')
    else return true
  }
]

export const cnpjRule = [
  (value) => {
    if (value) {
      const cleandedValue = value.replace(/[^\d]+/g, '')
      return (
        validateCNPJ(cleandedValue) || i18n.translate('rules.cnpjInvalid')
      )
    }
    return false || i18n.translate('rules.required')
  },
]

export const cpfRule = [
  (cpf) => {

    if (cpf == null || cpf == '' || cpf == undefined) return i18n.translate('rules.required')

    cpf = unmaskText(cpf)

    cpf = cpf.replace(/[^\d]+/g, '')

    if (
      cpf.length != 11 ||
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    )
      return i18n.translate('rules.cpf')

    // Valida 1o digito
    let add = 0
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i)
    let rev = 11 - (add % 11)
    if (rev == 10 || rev == 11) rev = 0
    if (rev != parseInt(cpf.charAt(9))) return i18n.translate('rules.cpfInvalid')

    // Valida 2o digito
    add = 0
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i)
    rev = 11 - (add % 11)
    if (rev == 10 || rev == 11) rev = 0
    if (rev != parseInt(cpf.charAt(10))) return i18n.translate('rules.cpfInvalid')
    return true
  },
]

export const cancelationLimitHoursRule = [
  (v) =>
    (v ? parseInt(v) <= 48 : true) ||
    i18n.translate('rules.cancelationLimitHours', { value: 48 }),
]

// Empty is valid: it means the default deadline applies
export const disputeCreationDaysLimitRule = [
  (v) => {
    if (isEmptyDisputeCreationDaysLimit(v)) return true

    const days = Number(v)
    return (
      (Number.isInteger(days) && days >= MIN_DISPUTE_CREATION_DAYS_LIMIT && days <= MAX_DISPUTE_CREATION_DAYS_LIMIT) ||
      i18n.translate('rules.disputeCreationDaysLimit', {
        min: MIN_DISPUTE_CREATION_DAYS_LIMIT,
        max: MAX_DISPUTE_CREATION_DAYS_LIMIT,
      })
    )
  },
]

export const rgRule = [
  (v) =>
    (v ? v.length >= 6 && v.length <= 14 : true) ||
    i18n.translate('rules.rg', { value: 6 }),
]

export const phoneRule = [
  (v) => (v ? v.length == 15 : false) || i18n.translate('rules.phone'),
]

export const requiredArray = [
  v =>
    Array.isArray(v) && v.length > 0 ||
    i18n.translate('rules.required')
]
